// Auto-split from i18n.js — language: ms
export default {
    translation: {
        // routes & menus
        Dashboard: 'Dashboard',
        'Space Data': 'Ruang',
        'Equipment Data': 'Peralatan',
        'Meter Data': 'Meter',
        'Tenant Data': 'Penyewa',
        'Store Data': 'Kedai',
        'Shopfloor Data': 'Bengkel',
        'Combined Equipment Data': 'Peralatan Gabungan',
        'Auxiliary System': 'Sistem Bantuan',
        Microgrid: 'Microgrid',
        'Energy Storage Power Station': 'Stesen Kuasa',
        'Photovoltaic Power Station': 'Stesen Kuasa',
        'Fault Alarm': 'Penggera Kesalahan',
        Monitoring: 'Pemantauan',
        'Advanced Reporting': 'Laporan Lanjutan',
        'Knowledge Base': 'Pangkalan Pengetahuan',
        'Energy Category Data': 'Kategori Tenaga',
        'Energy Item Data': 'Barangan Tenaga',
        Carbon: 'Emisi CO2',
        Cost: 'Kos',
        Output: 'Output',
        Income: 'Pendapatan',
        Efficiency: 'Kecekapan',
        Load: 'Memuatkan',
        Statistics: 'Statistik',
        'Batch Analysis': 'Analisis Kumpulan',
        Saving: 'MenyimpanⒺ',
        Plan: 'RancangⒺ',
        Prediction: 'PredictionⒺ',
        'Production': 'Production',
        'Space Production': 'Space Production',
        'Equipment Tracking': 'Penjejakan Peralatan',
        'Equipment Comparison': 'Perbandingan Peralatan',
        'Shopfloor Comparison': 'Perbandingan Peralatan',
        'Store Comparison': 'Perbandingan Peralatan',
        'Space Comparison': 'Perbandingan Peralatan',
        'Combined Equipment Comparison': 'Perbandingan Peralatan',
        'Tenant Comparison': 'perbandingan penyewa',
        'Environment Monitor': 'Monitor Alam Sekitar',
        'Meter Energy': 'Tenaga Meter',
        'Meter Prediction': 'Ramalan MeterⒺ',
        'Virtual Meter Prediction': 'Ramalan Meter MayaⒺ',
        'Offline Meter Prediction': 'Ramalan Meter Luar TalianⒺ',
        'Meter Carbon': 'Meter Emisi CO2',
        'Meter Cost': 'Kos Meter',
        'Meter Trend': 'Meter Trend',
        'Meter Realtime': 'Meter Masa Nyata',
        'Meter Saving': 'Penjimatan MeterⒺ',
        'Meter Plan': 'Pelan MeterⒺ',
        'Master Meter Submeters Balance': 'Baki Submeter Meter Master',
        'Meter Batch Analysis': 'Analisis Kelompok Meter',
        'Meter Comparison': 'Perbandingan Meter',
        'Meter Tracking': 'Penjejakan Meter',
        'Virtual Meter Saving': 'Penjimatan Meter MayaⒺ',
        'Virtual Meter Plan': 'Pelan Meter MayaⒺ',
        'Virtual Meter Energy': 'Tenaga Meter Maya',
        'Virtual Meter Carbon': 'Emisi CO2 Meter Maya',
        'Virtual Meter Cost': 'Kos Meter Maya',
        'Virtual Meter Batch Analysis': 'Analisis kelompok meter maya',
        'Virtual Meter Comparison': "Perbandingan Meter Maya",
        'Offline Meter Energy': 'Tenaga Meter Luar Talian',
        'Offline Meter Carbon': 'Emisi Meter CO2 Offline',
        'Offline Meter Cost': 'Kos Meter Luar Talian',
        'Offline Meter Batch Analysis': 'Analisis kelompok meter luar talian',
        'Offline Meter Saving': 'Penjimatan Meter Luar TalianⒺ',
        'Offline Meter Plan': 'Pelan Meter Luar TalianⒺ',
        'Offline Meter Input': 'Input Meter Luar Talian',
        'Tenant Bill': 'Bil Penyewa',
        'Energy Flow Diagram': 'Gambar Rajah Aliran Tenaga',
        'Distribution System': 'Sistem Pengedaran',
        'SVG System': 'Sistem Visualisasi SCADA',
        'Faults Data': 'Kesilapan',
        'Space Equipments': 'Peralatan Angkasa',
        'Combined Equipments': 'Peralatan Gabungan',
        'Energy Storage Power Station List': 'List',
        'Energy Storage Power Station Details': 'Details',
        'Energy Storage Power Station Reporting': 'Reporting',
        'Energy Storage Power Station Alarm': 'Alarm',
        'Energy Storage Power Station Maintenance': 'Maintenance',
        'Enter Production': 'Enter Production',
        'Multiple Microgrids': 'Multiple Microgirds',
        'Multiple Microgrids Dashboard': 'Dashboard',
        'Multiple Microgrids List': 'List',
        'Single Microgrid': 'Single Microgrid',
        'Single Microgrid Dashboard': 'Dashboard',
        'Single Microgrid Details': 'Details',
        'Single Microgrid Fault Alarm': 'Fault Alarm',
        'Microgrid Reports': 'Power Station Reports',
        'Microgrid Reports Energy': 'Energy',
        'Microgrid Reports Revenue': 'Revenue',
        'Microgrid Reports Parameters': 'Parameters',
        'Multiple Energy Storage Power Stations': 'Multiple Power Stations',
        'Multiple Energy Storage Power Stations Dashboard': 'Dashboard',
        'Multiple Energy Storage Power Stations List': 'List',
        'Single Energy Storage Power Station': 'Single Power Station',
        'Single Energy Storage Power Station Dashboard': 'Dashboard',
        'Single Energy Storage Power Station Details': 'Details',
        'Single Energy Storage Power Station Fault Alarm': 'Fault Alarm',
        'Energy Storage Power Station Reports': 'Power Station Reports',
        'Energy Storage Power Station Reports Energy': 'Energy',
        'Energy Storage Power Station Reports Revenue': 'Revenue',
        'Energy Storage Power Station Reports Parameters': 'Parameters',
        'Photovoltaic Power Station List': 'Power Station List',
        'Photovoltaic Power Station Details': 'Details',
        'Photovoltaic Power Station Reporting': 'Reporting',
        'Photovoltaic Power Station Alarm': 'Alarm',
        'Photovoltaic Power Station Maintenance': 'Maintenance',
        'Multiple Photovoltaic Power Stations': 'Multiple Power Stations',
        'Multiple Photovoltaic Power Stations Dashboard': 'Dashboard',
        'Multiple Photovoltaic Power Stations List': 'List',
        'Single Photovoltaic Power Station': 'Single Power Station',
        'Single Photovoltaic Power Station Dashboard': 'Dashboard',
        'Single Photovoltaic Power Station Details': 'Details',
        'Single Photovoltaic Power Station Fault Alarm': 'Fault Alarm',
        'Photovoltaic Power Station Reports': 'Power Station Reports',
        'Photovoltaic Power Station Reports Energy': 'Energy',
        'Photovoltaic Power Station Reports Revenue': 'Revenue',
        'Photovoltaic Power Station Reports Parameters': 'Parameters',
        'Work Order': 'Work Order',
        'Work Order Installation': 'Installation',
        'Work Order Repair': ' Repair',
        'Work Order Inspection': 'Inspection',
        'Total Number of Work Orders': 'Jumlah Bilangan Pesanan Kerja',
        'Number of New Work Orders': 'Bilangan Pesanan Kerja Baharu',
        'Number of Inprogress Work Orders': 'Bilangan Pesanan Kerja Sedang Bertindak',
        'Number of Done Work Orders': 'Bilangan Pesanan Kerja Selesai',
        'Fuel Indicator': 'Penggunaan bahan bakar',
        'Charge Energy Indicator': 'Mengecas Tenaga',
        'Discharge Energy Indicator': 'Tenaga Pelepasan',
        'Charge Cost Indicator': 'Kos Caj',
        'Discharge Revenue Indicator': 'Hasil Pelepasan',
        'HVAC': 'HVAC',
        'Fire Control': 'Kawalan Kebakaran',
        'Store Dashboard': 'Papan Pemuka Kedai',
        'Comprehensive overview of store energy performance': 'Gambaran keseluruhan prestasi tenaga kedai',
        'Total Stores': 'Jumlah Kedai',
        'Total Area': 'Jumlah Kawasan',
        'Active Meters': 'Meter Aktif',
        'Active Alerts': 'Amaran Aktif',
        'Total Energy Consumption': 'Jumlah Penggunaan Tenaga',
        'Carbon Emissions': 'Pelepasan Karbon',
        'Current Period': 'Tempoh Semasa',
        'Energy Consumption by Category': 'Penggunaan Tenaga mengikut Kategori',
        'Cost Distribution by Category': 'Pengagihan Kos mengikut Kategori',
        'Monthly Energy & Cost Trends': 'Aliran Tenaga dan Kos Bulanan',
        'Top 5 Energy Consuming Stores': '5 Kedai Penggunaan Tenaga Tertinggi',
        'Energy Category Details': 'Butiran Kategori Tenaga',
        'Store Performance Overview': 'Gambaran Prestasi Kedai',
        'YoY Change': 'Perubahan Tahunan',
        'Per m²': 'Setiap m²',
        'Usage Intensity': 'Keamatan Penggunaan',
        'Dashboard data loaded successfully': 'Data papan pemuka berjaya dimuatkan',
        'Failed to load dashboard data': 'Gagal memuatkan data papan pemuka',
        'Store Name': 'Nama Kedai',
        'Store Area': 'Kawasan Kedai',
        'Energy Consumption': 'Penggunaan Tenaga',
        'Consumption': 'Penggunaan',
        'last period': 'tempoh lepas',
        // Tenant Dashboard
        'Tenant Dashboard': 'Papan Pemuka Penyewa',
        'Comprehensive overview of tenant energy performance': 'Gambaran keseluruhan prestasi tenaga penyewa',
        'Total Tenants': 'Jumlah Penyewa',
        'Tenant Performance Overview': 'Gambaran Prestasi Penyewa',
        'Tenant Name': 'Nama Penyewa',
        'Tenant Area': 'Kawasan Penyewa',
        'Tenant Type': 'Jenis Penyewa',
        // Equipment Dashboard
        'Equipment Dashboard': 'Papan Pemuka Peralatan',
        'Total Equipments': 'Jumlah Peralatan',
        'Equipment Performance Overview': 'Gambaran Prestasi Peralatan',
        'Equipment Name': 'Nama Peralatan',
        'Equipment Type': 'Jenis Peralatan',
        'Total Energy': 'Jumlah Tenaga',
        'Total Sensors': 'Jumlah Penderia',
        'Increment Rate': 'Kadar Kenaikan',
        // Shopfloor Dashboard
        'Total Shopfloors': 'Jumlah bengkel',
        'Shopfloor Performance Overview': 'Gambaran keseluruhan prestasi bengkel',
        'Shopfloor Name': 'Nama bengkel',
        'Shopfloor Area': 'Kawasan bengkel',
        // Combined Equipment Dashboard
        'Total Combined Equipments': 'Jumlah Peralatan Gabungan',
        'Combined Equipment Performance Overview': 'Gambaran Keseluruhan Prestasi Peralatan Gabungan',
        'Combined Equipment Name': 'Nama Peralatan Gabungan',
        'Associated Equipments': 'Peralatan Berkaitan',

        // Dashboard
        'Welcome to QiXuan': 'Selamat datang ke QiXuan',
        'An Industry Leading Energy Management System':
            'Sistem Pengurusan Tenaga Terkemuka Industri',
        "This Year's Consumption CATEGORY VALUE UNIT": 'Penggunaan Tahun Ini {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Year's Costs CATEGORY VALUE UNIT": 'Kos Tahun Ini {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Month's Consumption CATEGORY VALUE UNIT": 'Penggunaan Bulan Ini {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Month's Generation CATEGORY VALUE UNIT": "This Month's Generation {{CATEGORY}} {{VALUE}} {{UNIT}}",
        "This Month's Costs CATEGORY VALUE UNIT": 'Kos bulan ini {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Consumption CATEGORY VALUE UNIT in The Same Period Last Year':
            'Penggunaan {{CATEGORY}} {{VALUE}} {{UNIT}} dalam tempoh yang sama tahun lepas',
        'Costs CATEGORY VALUE UNIT in The Same Period Last Year':
            'Bayaran {{CATEGORY}} {{VALUE}} {{UNIT}} dalam tempoh yang sama tahun lepas',
        'CATEGORY Consumption UNIT': '{{CATEGORY}} Penggunaan {{UNIT}}',
        'CATEGORY Costs UNIT': '{{CATEGORY}} Bayaran {{UNIT}}',
        // Entities
        Space: 'Ruang',
        Equipment: 'Peralatan',
        Meter: 'Meter',
        'Offline Meter': 'Meter Luar Talian',
        'Virtual Meter': 'Meter Maya',
        Tenant: 'Penyewa',
        Store: 'Kedai',
        Shopfloor: 'Bengkel',
        'Combined Equipment': 'Peralatan Gabungan',
        'Cost Center': 'Pusat Kos',
        Name: 'Nama',
        DisplayName: 'Nama Paparan',
        UserName: 'Nama Pengguna',
        Description: 'Keterangan',
        'Energy Category': 'Kategori Tenaga',
        'Child Spaces': 'Ruang Kanak-kanak',
        'Associated Equipment': 'Peralatan Berkaitan',
        //Energy Categories
        Electricity: 'Elektrik',
        Water: 'Air',
        'Natural Gas': 'Gas Asli',
        // SidePanelModal
        Settings: 'Seting',
        'Set your own customized style': 'Mengesetkan gaya tersuai anda sendiri',
        'Color Scheme': 'Skema Warna',
        'Choose the perfect color mode for your app': 'Pilih mod warna yang sesuai untuk apl anda',
        Light: 'Cahaya',
        Dark: 'Gelap',
        'RTL Mode': 'Mod RTL',
        'Switch your language direction': 'Tukar arah bahasa anda',
        'Fluid Layout': 'Susun atur cecair',
        'Toggle container layout system': 'Sistem susun atur kontena togol',
        'Navigation Position': 'Kedudukan Navigasi',
        'Vertical': 'Menegak',
        'Top': 'bahagian atas',
        'Combo': 'Gabungan',
        'Transparent': 'Lutsinar',
        'Inverted': 'Songsang',
        'Card': 'Kad',
        'Vibrant': 'Menarik',
        'Select a suitable navigation system for your web application':
            'Pilih sistem navigasi yang sesuai untuk aplikasi web anda',
        'Vertical Nav': 'Tentera Laut Menegak',
        'Top Nav': 'Tentera Laut Atas',
        'Vertical Navbar Style': 'Gaya Navbar Menegak',
        'Switch between styles for your vertical navbar': 'Bertukar antara gaya untuk bar navigasi menegak anda',
        Language: 'Bahasa',
        'Switch between languages': 'Bertukar antara bahasa',
        'language-zh_CN': '简体中文',
        'language-en': 'English',
        'language-de': 'Deutsch',
        'language-fr': 'Français',
        'language-es': 'Español',
        'language-ru': 'Русский',
        'language-ar': 'العربية',
        'language-vi': 'Tiếng Việt',
        'language-th': 'ภาษาไทย',
        'language-tr': 'Türkçe',
        'language-ms': 'Bahasa Melayu',
        'language-id': 'Bahasa Indonesia',
        'language-zh_TW': '繁體中文',
        'language-pt': 'Português',
        'language-ko_KR': '로그아웃',
        'language-it': 'Italiano',
        'language-pol': 'Polski',
        'language-nl': 'Nederlands',
        'language-jp': '日本語',
        'language-fa': 'فارسی',
        'Like What You See?': 'Seperti apa yang anda lihat?',
        'Get QiXuan now': 'Dapatkan QiXuan sekarang',
        Purchase: 'Editan Perusahaan',
        ContactInfo: 'Maklumat Hubungan',
        ProductWebsite: 'Laman Web Produk',
        CompanyWebsite: 'Laman Web Syarikat',
        SalesPhone: 'Telefon Jualan',
        // Query Panel
        'Base Period Begins': 'Tempoh Asas Bermula',
        'Base Period Ends': 'Tempoh Asas Berakhir',
        'Comparison Types': 'Jenis Perbandingan',
        'Year-Over-Year': 'Tahun Ke Tahun',
        'Month-On-Month': 'Bulan Ke Bulan',
        'Free Comparison': 'Perbandingan Percuma',
        'None Comparison': 'Tiada Perbandingan',
        'Reporting Period Begins': 'Tempoh pelaporan bermula',
        'Reporting Period Ends': 'Tempoh pelaporan berakhir',
        '(Optional)': '(Pilihan)',
        'Period Types': 'Jenis Tempoh',
        Yearly: 'Tahunan',
        Monthly: 'Bulanan',
        Weekly: 'Mingguan',
        Daily: 'Harian',
        Hourly: 'Jam',
        Submit: 'Hantar',
        'Input Energy Category': 'Kategori Tenaga Input',
        'Output Energy Category': 'Kategori Tenaga Output',
        'Fraction Parameter': 'Parameter pecahan',
        Search: 'Carian',
        //DateRangePicker
        sunday: 'Su',
        monday: 'Mo',
        tuesday: 'Tu',
        wednesday: 'We',
        thursday: 'Th',
        friday: 'Fr',
        saturday: 'Sa',
        ok: 'OK',
        today: 'Hari ini',
        yesterday: 'Semalam',
        hours: 'Jam',
        minutes: 'Minit',
        seconds: 'Saat',
        last7Days: '7 Hari Terakhir',
        tomorrow: 'Esok',
        dayAfterTomorrow: 'Lusa',
        next7Days: '7 Hari Akan Datang',
        'Select Date Range': 'Pilih Julat Tarikh',
        //Card Summaries and Line Charts
        'Base Period': 'Tempoh Asas',
        'Reporting Period': 'Tempoh Pelaporan',
        'Per Unit Area': 'Kawasan Unit',
        'Per Capita': 'Per Capita',
        'Per Unit Production': 'Pengeluaran Seunit',
        Baseline: 'Garis dasar',
        Actual: 'Sebenar',
        'Baseline Value - Actual Value': 'Garis dasar - Sebenar',
        'Average Load': 'Beban purata',
        'Maximum Load': 'Beban Maksimum',
        'Load Factor': 'Faktor Beban',
        'Ratio of Average Load to Maximum Load': 'Nisbah beban purata kepada beban maksimum',
        'Carbon Dioxide Emissions by Energy Category': 'Pelepasan karbon dioksida mengikut kategori tenaga',
        'Costs by Energy Category': 'Kos mengikut Kategori Tenaga',
        'Incomes by Energy Category': 'Pendapatan mengikut Kategori Tenaga',
        'Electricity Consumption by Time-Of-Use': 'Penggunaan elektrik mengikut masa penggunaan',
        'Electricity Carbon Dioxide Emissions by Time-Of-Use':
            'Pelepasan karbon dioksida elektrik mengikut masa penggunaan',
        'Electricity Cost by Time-Of-Use': 'Kos elektrik mengikut masa penggunaan',
        'CATEGORY UNIT Consumption by Energy Items': '{{CATEGORY}} {{UNIT}} Komperusi oleh Barangan Tenaga',
        'Ton of Standard Coal by Energy Category': 'Tan arang batu standard (TCE) mengikut kategori tenaga',
        'Ton of Carbon Dioxide Emissions by Energy Category':
            'Tan pelepasan karbon dioksida (TCO2E) mengikut kategori tenaga',
        'Reporting Period Consumption CATEGORY UNIT': 'Tempoh Pelaporan Penggunaan {{CATEGORY}} {{UNIT}}',
        'Reporting Period Prediction CATEGORY UNIT': 'Reporting Period Prediction {{CATEGORY}} {{UNIT}}',
        'EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
            '{{EQUIPMENT}} Tempoh Pelaporan Penggunaan {{CATEGORY}} {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
            '{{COMBINED_EQUIPMENT}} Tempoh Pelaporan Penggunaan {{CATEGORY}} {{UNIT}}',
        'CATEGORY VALUE UNIT': '{{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Consumption CATEGORY VALUE UNIT': 'Tempoh Pelaporan Penggunaan {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Prediction CATEGORY VALUE UNIT': 'Reporting Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Production PRODUCT VALUE UNIT': 'Reporting Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
        'Base Period Production PRODUCT VALUE UNIT': 'Base Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
        'Base Period Consumption CATEGORY VALUE UNIT': 'Tempoh Asas Penggunaan {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Prediction CATEGORY VALUE UNIT': 'Base Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Consumption ITEM CATEGORY UNIT': 'Tempoh Pelaporan Penggunaan {{ITEM}} {{CATEGORY}} {{UNIT}}',
        'Reporting Period Consumption ITEM CATEGORY VALUE UNIT':
            'Tempoh Pelaporan Penggunaan {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Consumption ITEM CATEGORY VALUE UNIT':
            'Tempoh Asas Penggunaan {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Child Space Proportion CATEGORY UNIT':
            'Perkadaran Ruang Kanak-kanak mengikut Kategori Tenaga {{CATEGORY}} {{UNIT}}',
        'Child Space Total Proportion': 'Jumlah Perkadaran Ruang Kanak-kanak',
        'Reporting Period Carbon Dioxide Emissions CATEGORY UNIT':
            'Tempoh pelaporan pelepasan karbon dioksida {{CATEGORY}} {{UNIT}}',
        'Reporting Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
            'Tempoh pelaporan pelepasan karbon dioksida {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
            'Tempoh Asas Pelepasan Karbon Dioksida {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Costs CATEGORY UNIT': 'Kos Tempoh Pelaporan {{CATEGORY}} {{UNIT}}',
        'Reporting Period Costs CATEGORY VALUE UNIT': 'Kos Tempoh Pelaporan {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Costs CATEGORY VALUE UNIT': 'Kos Tempoh Asas {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Output CATEGORY UNIT': 'Output Tempoh Pelaporan {{CATEGORY}} {{UNIT}}',
        'EQUIPMENT Reporting Period Output CATEGORY UNIT': '{{EQUIPMENT}} Output Tempoh Pelaporan {{CATEGORY}} {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Output CATEGORY UNIT':
            '{{COMBINED_EQUIPMENT}} Output Tempoh Pelaporan {{CATEGORY}} {{UNIT}}',
        'Reporting Period Output CATEGORY VALUE UNIT': 'Output Tempoh Pelaporan {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Output CATEGORY VALUE UNIT': 'Output Tempoh Asas {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Income CATEGORY UNIT': 'Pendapatan Tempoh Pelaporan {{CATEGORY}} {{UNIT}}',
        'Reporting Period Income CATEGORY VALUE UNIT': 'Pendapatan Tempoh Pelaporan {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Income CATEGORY VALUE UNIT': 'Pendapatan Tempoh Asas {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Total Income UNIT': 'Tempoh Pelaporan Jumlah Pendapatan {{UNIT}}',
        'Reporting Period Cumulative Efficiency NAME UNIT': 'Tempoh Pelaporan Kecekapan Kumulatif {{NAME}} {{UNIT}}',
        'EQUIPMENT Reporting Period Cumulative Efficiency UNIT':
            '{{EQUIPMENT}} Tempoh Pelaporan Kecekapan Kumulatif {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency UNIT':
            '{{COMBINED_EQUIPMENT}} Tempoh Pelaporan Kecekapan Komprehensif Kumulatif {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency VALUE UNIT':
            '{{COMBINED_EQUIPMENT}} Tempoh Pelaporan Kecekapan Komprehensif Kumulatif {{VALUE}} {{UNIT}}',
        'COMBINED_EQUIPMENT Base Period Cumulative Comprehensive Efficiency VALUE UNIT':
            '{{COMBINED_EQUIPMENT}} Tempoh Asas Kecekapan Komprehensif Kumulatif {{VALUE}} {{UNIT}}',
        'Instantaneous Efficiency UNIT': 'Kecekapan Seketika {{UNIT}}',
        'EQUIPMENT Instantaneous Efficiency UNIT': '{{EQUIPMENT}} Kecekapan Seketika {{UNIT}}',
        'Equipment Efficiency Indicator': 'Penunjuk Kecekapan Tenaga Peralatan',
        'COMBINED_EQUIPMENT Instantaneous Comprehensive Efficiency UNIT':
            '{{COMBINED_EQUIPMENT}} Kecekapan Komprehensif Seketika {{UNIT}}',
        'Reporting Period Cumulative Efficiency VALUE UNIT': 'Tempoh Pelaporan Kecekapan Kumulatif {{VALUE}} {{UNIT}}',
        'Reporting Period Cumulative Efficiency NAME VALUE UNIT':
            'Tempoh Pelaporan Kecekapan Kumulatif {{NAME}} {{VALUE}} {{UNIT}}',
        'Base Period Cumulative Efficiency VALUE UNIT': 'Tempoh Asas Kecekapan Kumulatif {{VALUE}} {{UNIT}}',
        'Base Period Cumulative Efficiency NAME VALUE UNIT':
            'Tempoh Asas Kecekapan Kumulatif {{NAME}} {{VALUE}} {{UNIT}}',
        'Base Period CATEGORY Maximum Load UNIT': 'Tempoh Asas {{CATEGORY}} Beban Maksimum {{UNIT}}',
        'Reporting Period CATEGORY Maximum Load UNIT': 'Tempoh Pelaporan {{CATEGORY}} Beban Maksimum {{UNIT}}',
        'Reporting Period CATEGORY Average Load UNIT': 'Tempoh Pelaporan {{CATEGORY}} Beban purata {{UNIT}}',
        'Reporting Period CATEGORY Load Factor': 'Tempoh Pelaporan {{CATEGORY}} Faktor Beban',
        'Base Period CATEGORY Average Load VALUE UNIT': 'Tempoh Asas {{CATEGORY}} Beban purata {{VALUE}} {{UNIT}}',
        'Reporting Period CATEGORY Average UNIT': 'Tempoh Pelaporan {{CATEGORY}} Nilai purata {{UNIT}}',
        'Reporting Period CATEGORY Maximum UNIT': 'Tempoh Pelaporan {{CATEGORY}} Nilai Maksimum {{UNIT}}',
        'Reporting Period CATEGORY Minimum UNIT': 'Tempoh Pelaporan {{CATEGORY}} Nilai Minimum {{UNIT}}',
        'Reporting Period CATEGORY Mean UNIT': 'Tempoh Pelaporan {{CATEGORY}} Min Aritmetik {{UNIT}}',
        'Reporting Period CATEGORY Median UNIT': 'Tempoh Pelaporan {{CATEGORY}} Median (Nilai Pertengahan) {{UNIT}}',
        'Reporting Period CATEGORY Stdev UNIT': 'Tempoh Pelaporan {{CATEGORY}} Sisihan Piawai Sampel {{UNIT}}',
        'Reporting Period CATEGORY Variance UNIT': 'Tempoh Pelaporan {{CATEGORY}} Sampel Varians {{UNIT}}',
        'Reporting Period Saving CATEGORY (Baseline - Actual) UNIT':
            'Penjimatan Tempoh Pelaporan {{CATEGORY}} (Garis dasar - Sebenar) {{UNIT}}',
        'Reporting Period Decreased CATEGORY (Baseline - Actual) UNIT':
            'Tempoh Pelaporan Berkurangan {{CATEGORY}} (Garis dasar - Sebenar) {{UNIT}}',
        'Reporting Period Saving CATEGORY VALUE UNIT': 'Penjimatan Tempoh Pelaporan {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Saving CATEGORY VALUE UNIT': 'Penjimatan Tempoh Asas {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Master Meter Consumption CATEGORY UNIT':
            'Tempoh Pelaporan Penggunaan Meter Induk {{CATEGORY}} {{UNIT}}',
        'Reporting Period Master Meter Consumption CATEGORY VALUE UNIT':
            'Tempoh Pelaporan Penggunaan Meter Induk {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Submeters Consumption CATEGORY UNIT':
            'Tempoh Pelaporan Penggunaan Submeter {{CATEGORY}} {{UNIT}}',
        'Reporting Period Submeters Consumption CATEGORY VALUE UNIT':
            'Tempoh Pelaporan Penggunaan Submeter {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Difference CATEGORY UNIT': 'Perbezaan Tempoh Pelaporan {{CATEGORY}} {{UNIT}}',
        'Reporting Period Percentage Difference': 'Perbezaan Peratusan Tempoh Pelaporan',
        'Reporting Period Difference CATEGORY VALUE UNIT': 'Perbezaan Tempoh Pelaporan {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Trend Values': 'Nilai Trend',
        'METER CATEGORY VALUE UNIT': '{{METER}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'EQUIPMENT CATEGORY VALUE UNIT': '{{EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'COMBINED_EQUIPMENT CATEGORY VALUE UNIT': '{{COMBINED_EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'SHOPFLOOR CATEGORY VALUE UNIT': '{{SHOPFLOOR}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'TENANT CATEGORY VALUE UNIT': '{{TENANT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        //FDD
        'Fault List': 'Senarai Kesalahan',
        'Reporting Period Number of Fault VALUE': 'Tempoh Pelaporan Bilangan Kesalahan {{VALUE}}',
        'All Faults': 'Semua Kesalahan',
        'Space Faults': 'Kesalahan Angkasa',
        'Number of All Faults': 'Bilangan Semua Kesalahan',
        'Number of Space Faults': 'Bilangan Kesalahan Ruang',
        'Total Number of Faults': 'Total Number of Faults',
        'Number of New Faults': 'Number of New Faults',
        'Number of Inprogress Faults': 'Number of Inprogress Faults',
        'Number of Done Faults': 'Number of Done Faults',
        //Data Panels
        'Ton of Standard Coal': 'Tan arang batu standard',
        'Ton of Carbon Dioxide Emissions': 'Tan pelepasan karbon dioksida',
        'Carbon Emissions Per Unit Of Energy Consumption': 'Pelepasan karbon setiap unit penggunaan tenaga',
        'Operating Characteristic Curve': 'Lengkung karakteristik operasi',
        Tariff: 'Tarif',
        'Detailed Data': 'Data terperinci',
        'Child Spaces Data': 'Data Ruang Kanak-kanak',
        'Associated Equipment Data': 'Data Peralatan Berkaitan',
        'This Year': 'Tahun ini',
        'The Same Period Last Year': 'Tempoh yang sama tahun lepas',
        'This Month': 'Bulan Ini',
        'This Day': 'Hari Ini',
        Total: 'Jumlah',
        'No data found': 'Tiada data ditemui',
        Export: 'Eksport',
        'AI Analysis': 'Analisis AI',
        Datetime: 'Masa tarikh',
        'Time-Of-Use Type': 'Jenis Masa Penggunaan',
        'Top-Peak': 'Puncak Atas',
        'On-Peak': 'On-Peak',
        'Mid-Peak': 'Pertengahan Puncak',
        'Off-Peak': 'Luar Puncak',
        'Deep': 'Deep-Valley',
        Percentage: 'Peratusan',
        //Realtime Chart
        'Trend in the last hour of Energy Value Point': 'Trend pada jam terakhir Titik Nilai Tenaga',
        Circuit: 'Litar',
        Point: 'Titik',
        'Realtime Value': 'Nilai Masa Nyata',
        //Meter Tracking
        'Meter List': 'Senarai Meter',
        'Edit Meter': 'Edit',
        'Start Value': 'Nilai Mula',
        'End Value': 'Nilai Akhir',
        'Difference Value': 'Perbezaan Nilai',
        'Start Integrity Rate': 'Mulakan Kadar Integriti(%)',
        'End Integrity Rate': 'Tamatkan Kadar Integriti(%)',
        'Full Integrity Rate': 'Kadar Integriti Penuh(%)',
        'Start Integrity Rate Description': 'Kadar Integriti Data Mula: Bahagian meter yang berjaya mendapatkan bacaan penggunaan tenaga pada masa mula daripada semua meter dalam tempoh statistik',
        'End Integrity Rate Description': 'Kadar Integriti Data Akhir: Bahagian meter yang berjaya mendapatkan bacaan penggunaan tenaga pada masa akhir daripada semua meter dalam tempoh statistik',
        'Full Integrity Rate Description': 'Kadar Integriti Data Penuh: Bahagian meter yang berjaya mendapatkan bacaan penggunaan tenaga pada masa mula dan akhir daripada semua meter dalam tempoh statistik',
        //Equipment Tracking
        'Equipment List': 'Senarai Peralatan',
        'Edit Equipment': 'Edit',
        //Profile Dropdown
        Feedback: 'Maklum balas',
        'Account Settings': 'Tetapan Akaun',
        Logout: 'Log keluar',
        //Authentication
        'Log in': 'Log masuk',
        'Email address': 'Alamat e-mel',
        'Phone Number': 'Nombor telefon',
        Password: 'Kata laluan',
        CaptchaCode: 'Captcha',
        Refresh: 'Refresh',
        'Remember me': 'Ingat saya',
        'Logged in as ': 'Log masuk sebagai ',
        'Forgot Password?': 'Lupa Kata Laluan?',
        'Forgot your password?': 'Lupa kata laluan anda?',
        "Enter your email and we'll send you a reset link":
            'Masukkan e-mel anda dan kami akan menghantar pautan set semula kepada anda',
        "Enter your email and we'll send you a registration link":
            'Masukkan e-mel anda dan kami akan menghantar pautan pendaftaran kepada anda',
        'Reset Password': 'Set Semula Kata Laluan',
        'Thanks for using QiXuan!': 'Terima kasih kerana menggunakan QiXuan!',
        'You are now successfully signed out': 'Anda kini berjaya mendaftar keluar',
        'Return to Login': 'Kembali ke Log Masuk',
        'Please check your email!': 'Sila semak e-mel anda!',
        'An email has been sent to ': 'E-mel telah dihantar kepada ',
        'Please click on the included link to reset your password':
            'Sila klik pada pautan yang disertakan untuk menetapkan semula kata laluan anda',
        'Please click on the included link to register your account':
            'Sila klik pada pautan yang disertakan untuk mendaftarkan akaun anda',
        'An email with password reset link is sent to ': 'Pautan e-mel dengan set semula kata laluan dihantar kepada ',
        'Change Password': 'Tukar Kata Laluan',
        'Old Password': 'Kata Laluan Lama',
        'New Password': 'Kata Laluan Baru',
        'Confirm Password': 'Sahkan Kata Laluan',
        'Update Password': 'Kemas kini Kata Laluan',
        'Password has been changed!': 'Kata laluan telah ditukar!',
        'Verification code has been sent to your inbox. \
  Please copy it to the input box below..':
            'Kod pengesahan telah dihantar ke peti masuk anda. \
  Sila salin ke kotak input di bawah.',
        'New to QiXuan': 'Baru mengenali QiXuan',
        'Create an account': 'Buat akaun',
        'EMAIL Account registration successful': '{{EMAIL}} Pendaftaran akaun berjaya',
        'Thanks for verifying your account!': 'Terima kasih kerana mengesahkan akaun anda!',
        'Your code is': 'Kod anda ialah',
        'Send verification code': 'Hantar kod pengesahan',
        'Please wait for NUMBER seconds': 'Sila tunggu {{NUMBER}} Saat',
        'Password reset': 'Penetapan semula kata laluan',
        'Please wait for approval': 'Sila tunggu kelulusan',
        //notification
        Notifications: 'Pemberitahuan',
        'Mark all as read': 'Tandakan semua sebagai dibaca',
        'View all': 'Semua',
        'Notification New': 'BARU',
        'Notification Earlier': 'AWAL',
        'Notification List': 'Senarai Pemberitahuan',
        'Bulk actions': 'Tindakan pukal',
        'Notification Subject': 'Subjek',
        'Notification Created Datetime': 'Dibuat Datetime',
        'Notification Priority': 'Keutamaan',
        'Notification Message': 'Mesej',
        'Notification Status': 'Status',
        'Notification Mark As Read': 'Tandakan Sebagai Baca',
        'Notification Mark As Acknowledged': 'Mengakui',
        'Notification Low': 'Rendah',
        'Notification Medium': 'Sederhana',
        'Notification High': 'Tinggi',
        'Notification Critical': 'Kritikal',
        'Notification Unread': 'Belum dibaca',
        'Notification Read': 'Membaca',
        'Notification Acknowledged': 'Diiktiraf',
        'Notification Archive': 'Arkib',
        'Notification Delete': 'Menghapuskan',
        'Notification Apply': 'Memohon',
        'Notification Start Datetime': 'Tarikh Mula',
        'Notification End Datetime': 'Tarikh Tamat',
        'Notification Update Datetime': 'Kemas kini Datetime',
        //Monitoring
        'Run Commands': 'Jalankan Perintah',
        'Pin Code': 'Kod Pin',
        'Unlock': 'Buka kunci',
        'Set Value': 'Tetapkan Nilai',
        'Fault Alarms': 'Penggera Kesalahan',
        'Instantaneous Efficiency VALUE UNIT': 'Kecekapan Seketika {{VALUE}} {{UNIT}}',
        'Communication Online': 'Dalam talian',
        'Communication Offline': 'Luar talian',
        'Equipment Status': 'Status Peralatan',
        'Equipment Running': 'Menjalankan',
        'Equipment Stopped': 'Berhenti',
        'Show Up to': 'Tunjukkan kepada',
        All: 'Semua',
        'FROM - TO of TOTAL': '{{FROM}} - {{TO}} daripada {{TOTAL}} Peralatan',
        //Microgrid
        'Microgrid Energy': 'Tenaga Microgrid',
        'Microgrid Revenue': 'Hasil Microgrid',
        'Microgrid Carbon': 'Mikrogrid Karbon',
        'Photovoltaic Generation': 'Penjanaan Fotovoltaik',
        'EV Charger Consumption': 'Penggunaan Pengecas EV',
        'Load Consumption': 'Penggunaan Beban',
        'Grid Buy': 'Pembelian Grid',
        'Grid Sell': 'Jualan Grid',
        'EV Charger': 'Pengecas EV',
        'Heat Pump': 'Pam Haba',
        'Photovoltaic': 'fotovoltaik',
        'PCS Run State': 'PCS Run State',
        'PCS Unknown': 'Tidak diketahui',
        'PCS Initializing': 'Memulakan',
        'PCS Standby': 'Bersedia',
        'PCS Shutdown': 'Matikan',
        'PCS Fault': 'Gagal',
        'PCS Running': 'Jalankan',
        'Battery Power': 'Battery power',
        'Photovoltaic Power': 'Kuasa fotovoltaik',
        'Grid Power': 'Kuasa grid',
        'Load Power': 'Muat kuasa',
        Reporting: 'Laporan',
        Maintenance: 'Kekal',
        'Serial Number': 'Nombor Siri',
        Address: 'Alamat',
        'Postal Code': 'Kod Postal',
        'Rated Capacity': 'Kemampuan Dinilai',
        'Rated Power': 'Kuasa Dinilai',
        Latitude: 'Latitud',
        Longitude: 'Longitud',
        'Strategy Management': 'Pengurusan strategi',
        'Charging Schedule': 'Memuatkan Jadual',
        'Charge Start Time': 'Muat Masa Mula',
        'Charge End Time': 'Masa Akhir Muat',
        'Discharge Start Time': 'Masa Mula Buang',
        'Discharge End Time': 'Masa Akhir Buang',
        'Total Rated Power': 'Jumlah Kuasa Dinilai',
        'Total Rated Capacity': 'Jumlah Kapasiti Dinilai',
        "Today's Charge": "Jumlah caj hari ini",
        "Today's Discharge": "Discharge hari ini",
        "Today's Generation": "Penjanaan kuasa hari ini",
        'Total Fuel Consumption': 'Total Fuel Consumption',
        'Total Charge': 'Jumlah caj',
        'Total Discharge': 'jumlah pelepasan',
        'Total Generation': 'Jumlah Penjanaan',
        'Total Revenue': 'Jumlah hasil',
        'Total Photovoltaic Generation': 'Jumlah Penjanaan Fotovoltaik',
        'Total EV Charger Consumption': 'Jumlah Penggunaan Pengecas EV',
        'Total Load Consumption': 'Jumlah Penggunaan Beban',
        'Total Grid Buy': 'Jumlah Pembelian Grid',
        'Total Grid Sell': 'Jumlah Jualan Grid',
        'Total Efficiency': 'Jumlah Kecekapan',
        'Discharge Achievement Rate': 'Kadar Pencapaian Pelepasan',
        // Revenue Indicator
        "Today's Cost": "Today's Cost",
        "Today's Income": "Today's Income",
        "Total Cost": "Total Cost",
        "Total Income": "Total Income",
        "Today's Revenue": "Today's Revenue",

        'Revenue Ranking': 'Kedudukan hasil',
        'Efficiency Ranking': 'Kedudukan kecekapan',
        'Charge Ranking': 'Kedudukan kapasiti pengecasan',
        'Discharge Ranking': 'Kedudukan pelepasan',
        'Number of Microgrids': 'Bilangan mikrogrid',
        'Number of Power Stations': 'Bilangan stesen janakuasa',
        'Microgrid List': 'Senarai Microgrid',
        'Select Microgrid': 'Pilih Microgrid',
        'Previous Page': 'Halaman sebelumnya',
        'Next Page': 'Muka surat seterusnya',
        '7 Days': '7 hari',
        'Charge UNIT': 'caj {{UNIT}}',
        'Discharge UNIT': 'pelepasan {{UNIT}}',
        'Generation UNIT': 'menjana tenaga elektrik {{UNIT}}',
        'Energy Indicator': 'indeks tenaga',
        'Revenue Indicator': 'Penunjuk hasil',
        'Carbon Indicator': 'indeks karbon',

        // Energy Storage Power Station
        'Battery Operating State': 'Keadaan Operasi Bateri',
        'Battery State': 'Status Bateri',
        'Battery Unknown': 'Tidak diketahui',
        'Battery Stopped': 'Berhenti',
        'Battery Reserved': 'Reserved', // 0
        'Battery Fault': 'Gagal', // 1
        'Battery Warning': 'Amaran', // 2
        'Battery Standby': 'Bersedia', // 3
        'Battery Prohibit DisCharging': 'Melarangkan Nyahmuat', // 4
        'Battery Prohibit Charging': 'Melarang Memuatkan', // 5
        'Battery Normal': 'Normal', // 6
        'Battery Charging': 'Memuatkan', // 7
        'Battery Discharging': 'Semasa pembuangan', // 8
        'Battery Idle': 'Idle', // 9
        'Phase of Lifecycle': 'Fasa Siklo Hidup',
        'Use Phase': 'Guna Tahap',
        'Commissioning Phase': 'Fasa Pemasangan',
        'Commissioning Date': 'Commissioning Date',
        'Installation Phase': 'Fasa Pemasangan',
        'Device Status': 'Status Peranti',
        'Basic Information': 'Maklumat Asas',
        'Gateway': 'Gateway',
        'Grid Meter': 'Grid Meter',
        'Load Meter': 'Load Meter',
        'ESS Meter': 'ESS Meter',
        'Total Active Power': 'Total Active Power',
        'Active Power A': 'Active Power A',
        'Active Power B': 'Active Power B',
        'Active Power C': 'Active Power C',
        'Total Reactive Power': 'Total Reactive Power',
        'Reactive Power A': 'Reactive Power A',
        'Reactive Power B': 'Reactive Power B',
        'Reactive Power C': 'Reactive Power C',
        'Total Apparent Power': 'Total Apparent Power',
        'Apparent Power A': 'Apparent Power A',
        'Apparent Power B': 'Apparent Power B',
        'Apparent Power C': 'Apparent Power C',
        'Total Power Factor': 'Total Power Factor',
        'Active Energy Import': 'Active Energy Import',
        'Active Energy Export': 'Active Energy Export',
        'Active Energy Net': 'Active Energy Net',

        'Generator': 'Generator',

        // Photovoltaic Power Station
        'Invertor': 'penyongsang',
        'Invertor Run State': 'Run State',
        'Invertor Unknown': 'Tidak diketahui',
        'Invertor Initializing': 'Memulakan',
        'Invertor Standby': 'Bersedia',
        'Invertor Shutdown': 'Matikan',
        'Invertor Fault': 'Gagal',
        'Invertor Running': 'Jalankan',

        //Advanced Reporting & Knowledge base
        'Created Datetime': 'Dicipta Datetime',
        'File Format': 'Format Fail',
        'File Size': 'Saiz Fail',
        Uploader: 'Pemuat naik',
        //Error
        "The page you're looking for is not found": 'Halaman yang anda cari tidak dijumpai',
        "Make sure the address is correct and that the page hasn't moved. ":
            'Pastikan alamat betul dan halaman tidak dialihkan. ',
        'If you think this is a mistake,': 'Jika anda fikir ini adalah kesilapan,',
        'contact us': 'Hubungi Kami',
        'Take me home': 'Bawa saya pulang',
        'Whoops, something went wrong!': 'Whoops, ada sesuatu yang tidak kena!',
        'Try refreshing the page, or going back and attempting the action again. ':
            'Cuba segarkan semula halaman atau kembali dan cuba lakukan tindakan sekali lagi. ',
        'If this problem persists,': 'Sekiranya masalah ini berterusan,',
        'Captcha Error': 'Ralat Captcha',
        'Confirm Password Error': 'Kata laluan sahkan tidak sepadan',
        'It looks like you clicked on an invalid password reset link. Please tryagain.':
            'Nampaknya anda mengklik pautan \
penetapan semula kata laluan yang tidak sah. Sila cubalah.',
        'It looks like you clicked on an invalid registration account link. Please tryagain.':
            'Nampaknya anda mengklik pautan \
akaun pendaftaran tidak sah. Sila cubalah.',
        //Tenant Bill
        'Lease Contract Number': 'Nombor Kontrak Pajakan',
        Download: 'Muat turun',
        Print: 'Cetakan',
        'Payment Notice': 'Notis Pembayaran',
        'Bill To': 'Bil Kepada',
        'Bill Number': 'Nombor Bil',
        'Bill Date': 'Tarikh Bil',
        'Payment Due Date': 'Tarikh Akhir Pembayaran',
        'Amount Payable': 'Amaun Perlu Dibayar',
        'Billing Period Start': 'Tempoh Pengebilan Bermula',
        'Billing Period End': 'Tempoh Tamat Tempoh Pengebilan',
        Quantity: 'Kuantiti',
        Price: 'Harga',
        Unit: 'Unit',
        Amount: 'Jumlah',
        Subtotal: 'Subjumlah',
        'VAT Output Tax': 'Cukai Output VAT',
        'Total Amount Payable': 'Jumlah Amaun Yang Perlu Dibayar',
        'Please make sure to pay on or before the payment due date above':
            'Sila pastikan anda membayar pada atau sebelum tarikh akhir pembayaran di atas',
        'Send money to the following account': 'Hantar wang ke akaun berikut',
        'Account Name': 'Nama Akaun',
        'Bank Name': 'Nama Bank',
        'Bank Address': 'Alamat Bank',
        'RMB Account': 'Akaun RMB',
        // button
        'Toggle Navigation': 'Togol Navigasi',
        // working calendar
        'Working Days': 'Hari Bekerja',
        'Non Working Days': 'Hari Bukan Bekerja',
        'Select Row': 'Sila Pilih Baris Data',
        // Offline Meter Input
        'Daily Value': 'Nilai Harian',
        Date: 'Tarikh',
        'Successfully Saved': 'Berjaya Diselamatkan',
        'Previous Data Is Empty': 'Data Sebelumnya Kosong',
        // API
        'API.ACCOUNT_UNLOCK_FAILED': 'Account unlock failed',
        'API.ADMINISTRATOR_SESSION_NOT_FOUND': 'Administrator session not found',
        'API.ADMINISTRATOR_SESSION_TIMEOUT': 'Administrator session timeout',
        'API.ADVANCED_REPORT_NOT_FOUND': 'Advanced report not found',
        'API.API_KEY_HAS_EXPIRED': 'Key has expired',
        'API.API_KEY_NAME_IS_ALREADY_IN_USE': 'Key name is already in use',
        'API.API_KEY_NOT_FOUND': 'Key not found',
        'API.BAD_REQUEST': 'Bad request',
        'API.BALANCING_PRICE_POINT_NOT_FOUND': 'Balancing price point not found',
        'API.BATTERY_STATE_POINT_NOT_FOUND': 'Battery state point not found',
        'API.BUY_METER_NOT_FOUND': 'Buy meter not found',
        'API.CANNOT_SET_EXISTING_SUBMETER_AS_MASTER_METER': 'Cannot set existing submeter as master meter',
        'API.CHARGE_METER_NOT_FOUND': 'Charge meter not found',
        'API.COMBINED_EQUIPMENT_COMMAND_RELATION_EXISTS': 'Combined equipment command relation exists',
        'API.COMBINED_EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Combined equipment command relation not found',
        'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_EXISTS': 'Combined equipment equipment relation exists',
        'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_NOT_FOUND': 'Combined equipment equipment relation not found',
        'API.COMBINED_EQUIPMENT_METER_RELATION_EXISTS': 'Combined equipment meter relation exists',
        'API.COMBINED_EQUIPMENT_METER_RELATION_NOT_FOUND': 'Combined equipment meter relation not found',
        'API.COMBINED_EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Combined equipment name is already in use',
        'API.COMBINED_EQUIPMENT_NOT_FOUND': 'Combined equipment not found',
        'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Combined equipment offline meter relation exists',
        'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Combined equipment offline meter relation not found',
        'API.COMBINED_EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Combined equipment parameter name is already in use',
        'API.COMBINED_EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Combined equipment parameter not found or not match',
        'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Combined equipment virtual meter relation exists',
        'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Combined equipment virtual meter relation not found',
        'API.COMMAND_NAME_IS_ALREADY_IN_USE': 'Command name is already in use',
        'API.COMMAND_NOT_FOUND': 'Command not  found',
        'API.CONTACT_NAME_IS_ALREADY_IN_USE': 'Contact name is already in use',
        'API.CONTACT_NOT_FOUND': 'Contact not found',
        'API.COOLING_METER_NOT_FOUND': 'Cooling meter not found',
        'API.COST_CENTER_EXTERNAL_ID_EXISTS': 'Cost center external id exists',
        'API.COST_CENTER_NAME_EXISTS': 'Cost center name exists',
        'API.COST_CENTER_NOT_FOUND': 'Cost center not found',
        'API.COST_FILE_NOT_FOUND': 'Cost file not found',
        'API.DATA_REPAIR_FILE_NOT_FOUND': 'Data repair file not found',
        'API.DATA_SOURCE_NAME_IS_ALREADY_IN_USE': 'Data source name is already in use',
        'API.DATA_SOURCE_NOT_FOUND': 'Data source not found',
        'API.DATABASE_ERROR': 'Database error',
        'API.DATE_IS_ALREADY_IN_WORKING_CALENDAR': 'Date Is Already In Working Calendar',
        'API.DATE_LOCAL_NOT_FOUND': 'Date local not found',
        'API.DISCHARGE_METER_NOT_FOUND': 'Discharge meter not found',
        'API.DISTRIBUTION_CIRCUIT_NAME_IS_ALREADY_IN_USE': 'Distribution circuit name is already in use',
        'API.DISTRIBUTION_CIRCUIT_NOT_FOUND': 'Distribution circuit not found',
        'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_EXISTS': 'Distribution circuit point relation exists',
        'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_NOT_FOUND': 'Distribution circuit point relation not found',
        'API.DISTRIBUTION_SYSTEM_NAME_IS_ALREADY_IN_USE': 'Distribution system name is already in use',
        'API.DISTRIBUTION_SYSTEM_NOT_FOUND': 'Distribution system not found',
        'API.ELECTRICITY_METER_NOT_FOUND': 'Electricity meter not found',
        'API.EMAIL_IS_ALREADY_IN_USE': 'Email is already in use',
        'API.EMAIL_MESSAGE_NOT_FOUND': 'Email message not found',
        'API.EMAIL_NOT_FOUND': 'Email not found',
        'API.EMAIL_SERVER_HOST_IS_ALREADY_IN_USE': 'Email server host is already in use',
        'API.EMAIL_SERVER_NOT_FOUND': 'Email server not found',
        'API.EMPTY_VARIABLES_ARRAY': 'Empty variables array',
        'API.ENERGY_CATEGORY_NAME_IS_ALREADY_IN_USE': 'Energy category name is already in use',
        'API.ENERGY_CATEGORY_NOT_FOUND': 'Energy category not found',
        'API.ENERGY_CATEGORY_USED_IN_ENERGY_ITEMS': 'Energy category used in energy items',
        'API.ENERGY_CATEGORY_USED_IN_METER': 'Energy category used in meter',
        'API.ENERGY_CATEGORY_USED_IN_OFFLINE_METER': 'Energy category used in offline meter',
        'API.ENERGY_CATEGORY_USED_IN_TARIFFS': 'Energy category used in tariffs',
        'API.ENERGY_CATEGORY_USED_IN_VIRTUAL_METER': 'Energy category used in virtual meter',
        'API.ENERGY_FLOW_DIAGRAM_LINK_IS_ALREADY_IN_USE': 'Energy flow diagram link is already in use',
        'API.ENERGY_FLOW_DIAGRAM_LINK_NOT_FOUND_OR_NOT_MATCH': 'Energy flow diagram link not found or not match',
        'API.ENERGY_FLOW_DIAGRAM_NAME_IS_ALREADY_IN_USE': 'Energy flow diagram name is already in use',
        'API.ENERGY_FLOW_DIAGRAM_NODE_NAME_IS_ALREADY_IN_USE': 'Energy flow diagram node name is already in use',
        'API.ENERGY_FLOW_DIAGRAM_NODE_NOT_FOUND_OR_NOT_MATCH': 'Energy flow diagram node not found or not match',
        'API.ENERGY_FLOW_DIAGRAM_NOT_FOUND': 'Energy flow diagram not found',
        'API.ENERGY_ITEM_DOES_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energy item does not belong to energy category',
        'API.ENERGY_ITEM_IS_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energy item is not belong to energy category',
        'API.ENERGY_ITEM_NAME_IS_ALREADY_IN_USE': 'Energy item name is already in use',
        'API.ENERGY_ITEM_NOT_FOUND': 'Energy item not found',
        'API.ENERGY_ITEM_USED_IN_METER': 'Energy item used in meter',
        'API.ENERGY_ITEM_USED_IN_OFFLINE_METER': 'Energy item used in offline meter',
        'API.ENERGY_ITEM_USED_IN_VIRTUAL_METER': 'Energy item used in virtual meter',
        'API.ENERGY_STORAGE_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Energy storage power station name is already in use',
        'API.ENERGY_STORAGE_POWER_STATION_NOT_FOUND': 'Energy storage power station not found',
        'API.EQUIPMENT_COMMAND_RELATION_EXISTS': 'Equipment command relation exists',
        'API.EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Equipment command relation not found',
        'API.EQUIPMENT_METER_RELATION_EXISTS': 'Equipment meter relation exists',
        'API.EQUIPMENT_METER_RELATION_NOT_FOUND': 'Equipment meter relation not found',
        'API.EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Equipment name is already in use',
        'API.EQUIPMENT_NOT_FOUND': 'Equipment not found',
        'API.EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Equipment offline meter relation exists',
        'API.EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Equipment offline meter relation not found',
        'API.EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Equipment parameter name is already in use',
        'API.EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Equipment parameter not found or not match',
        'API.EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Equipment virtual meter relation exists',
        'API.EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Equipment virtual meter relation not found',
        'API.ERROR': 'Error',
        'API.EXCEPTION': 'Exception',
        'API.FAILED_TO_READ_REQUEST_STREAM': 'Failed to read request stream',
        'API.FAILED_TO_RESTORE_COST_FILE': 'Failed to restore cost file',
        'API.FAILED_TO_RESTORE_DATA_REPAIR_FILE': 'Failed to restore data repair file',
        'API.FAILED_TO_RESTORE_KNOWLEDGE_FILE': 'Failed to restore knowledge file',
        'API.FAILED_TO_RESTORE_OFFLINE_METER_FILE': 'Failed to restore offline meter file',
        'API.FAILED_TO_SAVE_OFFLINE_METER_FILE': 'Failed to save offline meter file',
        'API.FAILED_TO_UPLOAD_ATTACHMENT_FILE': 'Failed to upload attachment file',
        'API.FAILED_TO_UPLOAD_COST_FILE': 'Failed to upload cost file',
        'API.FAILED_TO_UPLOAD_DATA_REPAIR_FILE': 'Failed to upload data repair file',
        'API.FAILED_TO_UPLOAD_KNOWLEDGE_FILE': 'Failed to upload knowledge file',
        'API.FAILED_TO_UPLOAD_OFFLINE_METER_FILE': 'Failed to upload offline meter file',
        'API.GATEWAY_NAME_IS_ALREADY_IN_USE': 'Gateway name is already in use',
        'API.GATEWAY_NOT_FOUND': 'Gateway not found',
        'API.HEAT_METER_NOT_FOUND': 'Heat meter not found',
        'API.INVALID_': 'Invalid ',
        'API.INVALID_ACKNOWLEDGE_CODE': 'Invalid acknowledge code',
        'API.INVALID_ADDRESS': 'Invalid address',
        'API.INVALID_ADDRESS_VALUE': 'Invalid address value',
        'API.INVALID_ADVANCED_REPORT_ID': 'Invalid advanced report id',
        'API.INVALID_API_KEY_ID': 'Invalid api key id',
        'API.INVALID_API_KEY_NAME': 'Invalid api key name',
        'API.INVALID_AREA_VALUE': 'Invalid area value',
        'API.INVALID_BALANCING_PRICE_POINT_ID': 'Invalid balancing price point ID',
        'API.INVALID_BASE_PERIOD_END_DATETIME': 'Invalid base period end datetime',
        'API.INVALID_BASE_PERIOD_START_DATETIME': 'Invalid base period start datetime',
        'API.INVALID_BATTERY_STATE_POINT_ID': 'Invalid battery state point ID',
        'API.INVALID_BAUD_RATE': 'Invalid baud rate',
        'API.INVALID_BUILDINGS_VALUE': 'Invalid buildings value',
        'API.INVALID_BUY_METER_ID': 'Invalid buy meter id',
        'API.INVALID_CAPACITY': 'Invalid capacity',
        'API.INVALID_CATEGORY': 'Invalid category',
        'API.INVALID_CHANNEL': 'Invalid channel',
        'API.INVALID_CHARGE_METER_ID': 'Invalid charge meter id',
        'API.INVALID_COMBINED_EQUIPMENT_ID': 'Invalid combined equipment id',
        'API.INVALID_COMBINED_EQUIPMENT_NAME': 'Invalid combined equipment name',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_ID': 'Invalid combined equipment parameter id',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_NAME': 'Invalid combined equipment parameter name',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_TYPE': 'Invalid combined equipment parameter type',
        'API.INVALID_COMBINED_EQUIPMENT_UUID': 'Invalid combined equipment uuid',
        'API.INVALID_COMMAND_ID': 'Invalid command id',
        'API.INVALID_COMMAND_NAME': 'Invalid command name',
        'API.INVALID_CONNECTION': 'Invalid connection',
        'API.INVALID_CONSTANT_VALUE': 'Invalid constant value',
        'API.INVALID_CONTACT_ID': 'Invalid contact id',
        'API.INVALID_CONTACT_NAME': 'Invalid contact name',
        'API.INVALID_COOLING_METER_ID': 'Invalid cooling meter id',
        'API.INVALID_COST_CENTER_ID': 'Invalid cost center id',
        'API.INVALID_COST_FILE_ID': 'Invalid cost file id',
        'API.INVALID_CREATED_DATETIME': 'Invalid created datetime',
        'API.INVALID_DATA_REPAIR_FILE_ID': 'Invalid data repair file id',
        'API.INVALID_DATA_SOURCE_ID': 'Invalid data source id',
        'API.INVALID_DATA_SOURCE_NAME': 'Invalid data source name',
        'API.INVALID_DATA_SOURCE_PROTOCOL': 'Invalid data source protocol',
        'API.INVALID_DATE_LOCAL': 'Invalid date local',
        'API.INVALID_DENOMINATOR_METER_UUID': 'Invalid denominator meter uuid',
        'API.INVALID_DISCHARGE_METER_ID': 'Invalid discharge meter id',
        'API.INVALID_DISPLAY_NAME': 'Invalid display name',
        'API.INVALID_DISTRIBUTION_CIRCUIT_ID': 'Invalid distribution circuit id',
        'API.INVALID_DISTRIBUTION_CIRCUIT_NAME': 'Invalid distribution circuit name',
        'API.INVALID_DISTRIBUTION_ROOM': 'Invalid distribution room',
        'API.INVALID_DISTRIBUTION_SYSTEM_ID': 'Invalid distribution system id',
        'API.INVALID_DISTRIBUTION_SYSTEM_NAME': 'Invalid distribution system name',
        'API.INVALID_ELECTRICITY_METER_ID': 'Invalid Electricity meter id',
        'API.INVALID_EMAIL': 'Invalid email',
        'API.INVALID_EMAIL_MESSAGE_ID': 'Invalid email message id',
        'API.INVALID_EMAIL_SERVER_HOST': 'Invalid email server host',
        'API.INVALID_EMAIL_SERVER_ID': 'Invalid email server id',
        'API.INVALID_END_DATE_FORMAT': 'Invalid end date format',
        'API.INVALID_END_DATETIME': 'Invalid end datetime',
        'API.INVALID_ENERGY_CATEGORY_ID': 'Invalid energy category id',
        'API.INVALID_ENERGY_CATEGORY_NAME': 'Invalid energy category name',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_ID': 'Invalid energy flow diagram id',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_LINK_ID': 'Invalid energy flow diagram link id',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NAME': 'Invalid energy flow diagram name',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_ID': 'Invalid energy flow diagram node id',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_NAME': 'Invalid energy flow diagram node name',
        'API.INVALID_ENERGY_ITEM_ID': 'Invalid energy item id',
        'API.INVALID_ENERGY_ITEM_NAME': 'Invalid energy item name',
        'API.INVALID_ENERGY_STORAGE_POWER_STATION_ID': 'Invalid energy storage power station ID',
        'API.INVALID_ENERGY_STORAGE_POWER_STATION_NAME': 'Invalid energy storage power station name',
        'API.INVALID_EQUATION_IN_EXPRESSION': 'Invalid equation in expression',
        'API.INVALID_EQUIPMENT_ID': 'Invalid equipment id',
        'API.INVALID_EQUIPMENT_NAME': 'Invalid equipment name',
        'API.INVALID_EQUIPMENT_PARAMETER_ID': 'Invalid equipment parameter id',
        'API.INVALID_EQUIPMENT_PARAMETER_NAME': 'Invalid equipment parameter name',
        'API.INVALID_EQUIPMENT_PARAMETER_TYPE': 'Invalid equipment parameter type',
        'API.INVALID_EQUIPMENT_UUID': 'Invalid equipment uuid',
        'API.INVALID_EXPIRES_DATETIME': 'Invalid expires datetime',
        'API.INVALID_EXPRESSION': 'Invalid expression',
        'API.INVALID_EXPRESSION_OBJECT': 'Invalid expression object',
        'API.INVALID_FDD_CODE': 'Invalid fdd code',
        'API.INVALID_FLOORS_VALUE': 'Invalid floors value',
        'API.INVALID_FROM_ADDR': 'Invalid from addr',
        'API.INVALID_GATEWAY_ID': 'Invalid gateway id',
        'API.INVALID_GATEWAY_NAME': 'Invalid gateway name',
        'API.INVALID_HEAT_METER_ID': 'Invalid heat meter id',
        'API.INVALID_HIGH_LIMIT_VALUE': 'Invalid high limit value',
        'API.INVALID_HOURLY_HIGH_LIMIT_VALUE': 'Invalid hourly high limit value',
        'API.INVALID_HOURLY_LOW_LIMIT_VALUE': 'Invalid hourly low limit value',
        'API.INVALID_Id': 'Invalid id',
        'API.INVALID_IS_ADMIN_VALUE': 'Invalid is admin value',
        'API.INVALID_IS_COST_DATA_DISPLAYED': 'Invalid is cost data displayed',
        'API.INVALID_IS_COUNTED_VALUE': 'Invalid is counted value',
        'API.INVALID_IS_ENABLED': 'Invalid is enabled',
        'API.INVALID_IS_HIDDEN': 'Invalid is hidden',
        'API.INVALID_IS_IN_LEASE_VALUE': 'Invalid is in lease value',
        'API.INVALID_IS_INPUT_COUNTED_VALUE': 'Invalid is input counted value',
        'API.INVALID_IS_KEY_TENANT_VALUE': 'Invalid is key tenant value',
        'API.INVALID_IS_OUTPUT_COUNTED_VALUE': 'Invalid is output counted value',
        'API.INVALID_IS_OUTPUT_VALUE': 'Invalid is output value',
        'API.INVALID_IS_READ_ONLY_VALUE': 'Invalid is read only value',
        'API.INVALID_IS_TREND_VALUE': 'Invalid is trend value',
        'API.INVALID_IS_VIRTUAL_VALUE': 'Invalid is virtual value',
        'API.INVALID_KGCE': 'Invalid kgce',
        'API.INVALID_KGCO2E': 'Invalid kgco2e',
        'API.INVALID_KNOWLEDGE_FILE_ID': 'Invalid knowledge file id',
        'API.INVALID_LATITUDE_VALUE': 'Invalid latitude value',
        'API.INVALID_LEASE_NUMBER_VALUE': 'Invalid lease number value',
        'API.INVALID_LONGITUDE_VALUE': 'Invalid longitude value',
        'API.INVALID_LOW_LIMIT_VALUE': 'Invalid low limit value',
        'API.INVALID_MASTER_METER_ID': 'Invalid master meter id',
        'API.INVALID_MENU_ID': 'Invalid menu id',
        'API.INVALID_MESSAGE_DATA': 'Invalid message data',
        'API.INVALID_MESSAGE_TEMPLATE': 'Invalid message template',
        'API.INVALID_MESSAGE_TEMPLATE_ID': 'Invalid message template id',
        'API.INVALID_MESSAGE_VALUE': 'Invalid message value',
        'API.INVALID_METER_ID': 'Invalid meter id',
        'API.INVALID_METER_NAME': 'Invalid meter name',
        'API.INVALID_METER_UUID': 'Invalid meter uuid',
        'API.INVALID_MICROGRID_BATTERY_ID': 'Invalid microgrid battery id',
        'API.INVALID_MICROGRID_BATTERY_NAME': 'Invalid microgrid battery name',
        'API.INVALID_MICROGRID_EVCHARGER_ID': 'Invalid microgrid evcharger id',
        'API.INVALID_MICROGRID_EVCHARGER_NAME': 'Invalid microgrid evcharger name',
        'API.INVALID_MICROGRID_GENERATOR_ID': 'Invalid microgrid generator id',
        'API.INVALID_MICROGRID_GENERATOR_NAME': 'Invalid microgrid generator name',
        'API.INVALID_MICROGRID_GRID_ID': 'Invalid microgrid grid id',
        'API.INVALID_MICROGRID_GRID_NAME': 'Invalid microgrid grid name',
        'API.INVALID_MICROGRID_HEATPUMP_ID': 'Invalid microgrid heatpump id',
        'API.INVALID_MICROGRID_HEATPUMP_NAME': 'Invalid microgrid heatpump name',
        'API.INVALID_MICROGRID_ID': 'Invalid microgrid id',
        'API.INVALID_MICROGRID_LOAD_ID': 'Invalid microgrid load id',
        'API.INVALID_MICROGRID_LOAD_NAME': 'Invalid microgrid load name',
        'API.INVALID_MICROGRID_NAME': 'Invalid microgrid name',
        'API.INVALID_MICROGRID_PHOTOVOLTAIC_ID': 'Invalid microgrid photovoltaic ID',
        'API.INVALID_MICROGRID_PHOTOVOLTAIC_NAME': 'Invalid microgrid photovoltaic name',
        'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_ID': 'Invalid microgrid power conversion system ID',
        'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_NAME': 'Invalid microgrid microgrid power conversion system name',
        'API.INVALID_MICROGRID_UUID': 'Invalid microgrid UUID',
        'API.INVALID_NAME_VALUE': 'Invalid name value',
        'API.INVALID_NEW_PASSWORD': 'Invalid new password',
        'API.INVALID_NON_WORKING_DAY_ID': 'Invalid non working day ID',
        'API.INVALID_NOTIFICATION_ID': 'Invalid notification id',
        'API.INVALID_NUMERATOR_METER_UUID': 'Invalid numerator meter uuid',
        'API.INVALID_OBJECT_TYPE': 'Invalid object type',
        'API.INVALID_OFFLINE_METER_DATA': 'Invalid offline meter data',
        'API.INVALID_OFFLINE_METER_FILE_ID': 'Invalid offline meter file id',
        'API.INVALID_OFFLINE_METER_ID': 'Invalid offline meter id',
        'API.INVALID_OFFLINE_METER_NAME': 'Invalid offline meter name',
        'API.INVALID_OFFLINE_METER_UUID': 'Invalid offline meter uuid',
        'API.INVALID_OFFSET_CONSTANT_VALUE': 'Invalid offset constant value',
        'API.INVALID_OLD_PASSWORD': 'Invalid old password',
        'API.INVALID_OPENID': 'Invalid openid',
        'API.INVALID_PARENT_SPACE_ID': 'Invalid parent space id',
        'API.INVALID_PASSWORD': 'Invalid password',
        'API.INVALID_PAYLOAD': 'Invalid payload',
        'API.INVALID_PEAK_CURRENT': 'Invalid peak current',
        'API.INVALID_PEAK_LOAD': 'Invalid peak load',
        'API.INVALID_PERIOD_TYPE': 'Invalid period type',
        'API.INVALID_PHOTOVOLTAIC_POWER_STATION_ID': 'Invalid photovoltaic power station ID',
        'API.INVALID_PHOTOVOLTAIC_POWER_STATION_NAME': 'Invalid photovoltaic power station name',
        'API.INVALID_POINT_ID': 'Invalid point id',
        'API.INVALID_POINT_NAME': 'Invalid point name',
        'API.INVALID_PORT': 'Invalid port',
        'API.INVALID_POSTAL_CODE_VALUE': 'Invalid postal code value',
        'API.INVALID_POWER_POINT_ID': 'Invalid power point id',
        'API.INVALID_PRIORITY': 'Invalid priority',
        'API.INVALID_PRIVILEGE': 'Invalid privilege',
        'API.INVALID_PRIVILEGE_DATA': 'Invalid privilege data',
        'API.INVALID_PRIVILEGE_ID': 'Invalid privilege id',
        'API.INVALID_PRIVILEGE_NAME': 'Invalid privilege name',
        'API.INVALID_RATIO_VALUE': 'Invalid ratio value',
        'API.INVALID_RECIPIENT_EMAIL': 'Invalid recipient email',
        'API.INVALID_RECIPIENT_MOBILE': 'Invalid recipient mobile',
        'API.INVALID_RECIPIENT_NAME': 'Invalid recipient name',
        'API.INVALID_RECIPIENT_OPENID': 'Invalid recipient openid',
        'API.INVALID_REPLY': 'Invalid reply',
        'API.INVALID_REPORTING_PERIOD_END_DATETIME': 'Invalid reporting period end datetime',
        'API.INVALID_REPORTING_PERIOD_START_DATETIME': 'Invalid reporting period start datetime',
        'API.INVALID_REQUIRES_AUTHENTICATION': 'Invalid requires authentication',
        'API.INVALID_ROOMS_VALUE': 'Invalid rooms value',
        'API.INVALID_RULE_ID': 'Invalid rule id',
        'API.INVALID_RULE_NAME': 'Invalid rule name',
        'API.INVALID_RUN_STATE_POINT_ID': 'Invalid run state point ID',
        'API.INVALID_SCHEDULED_DATETIME': 'Invalid scheduled datetime',
        'API.INVALID_SELL_METER_ID': 'Invalid sell meter id',
        'API.INVALID_SENSOR_ID': 'Invalid sensor id',
        'API.INVALID_SENSOR_NAME': 'Invalid sensor name',
        'API.INVALID_SENSOR_UUID': 'Invalid sensor uuid',
        'API.INVALID_SERIAL_NUMBER': 'Invalid serial number',
        'API.INVALID_SERIAL_PORT': 'Invalid serial port',
        'API.INVALID_SESSION_PLEASE_RE_LOGIN': 'Invalid session please re-login',
        'API.INVALID_SET_VALUE': 'Invalid set value',
        'API.INVALID_SHOPFLOOR_ID': 'Invalid shopfloor id',
        'API.INVALID_SHOPFLOOR_NAME': 'Invalid shopfloor name',
        'API.INVALID_SHOPFLOOR_UUID': 'Invalid shopfloor uuid',
        'API.INVALID_SOURCE_NODE_ID': 'Invalid source node id',
        'API.INVALID_SPACE_ID': 'Invalid space id',
        'API.INVALID_SPACE_NAME': 'Invalid space name',
        'API.INVALID_SPACE_UUID': 'Invalid space uuid',
        'API.INVALID_START_DATE_FORMAT': 'Invalid start date format',
        'API.INVALID_START_DATETIME': 'Invalid start datetime',
        'API.INVALID_STATUS': 'Invalid status',
        'API.INVALID_STORE_ID': 'Invalid store id',
        'API.INVALID_STORE_NAME': 'Invalid store name',
        'API.INVALID_STORE_TYPE_DESCRIPTION': 'Invalid store type description',
        'API.INVALID_STORE_TYPE_ID': 'Invalid store type id',
        'API.INVALID_STORE_TYPE_NAME': 'Invalid store type name',
        'API.INVALID_STORE_TYPE_SIMPLIFIED_CODE': 'Invalid store type simplified code',
        'API.INVALID_STORE_UUID': 'Invalid store uuid',
        'API.INVALID_SUBJECT_VALUE': 'Invalid subject value',
        'API.INVALID_SVG': 'Invalid SVG',
        'API.INVALID_SWITCHGEAR': 'Invalid switchgear',
        'API.INVALID_TARGET_NODE_ID': 'Invalid target node id',
        'API.INVALID_TARIFF_BLOCK_PRICING': 'Invalid tariff block pricing',
        'API.INVALID_TARIFF_ID': 'Invalid tariff id',
        'API.INVALID_TARIFF_TIME_OF_USE_PRICING': 'Invalid tariff time of use pricing',
        'API.INVALID_TARIFF_TYPE': 'Invalid tariff type',
        'API.INVALID_TENANT_ID': 'Invalid tenant id',
        'API.INVALID_TENANT_NAME': 'Invalid tenant name',
        'API.INVALID_TENANT_TYPE_DESCRIPTION': 'Invalid tenant type description',
        'API.INVALID_TENANT_TYPE_ID': 'Invalid tenant type id',
        'API.INVALID_TENANT_TYPE_NAME': 'Invalid tenant type name',
        'API.INVALID_TENANT_TYPE_SIMPLIFIED_CODE': 'Invalid tenant type simplified code',
        'API.INVALID_TENANT_UUID': 'Invalid tenant uuid',
        'API.INVALID_TEXT_MESSAGE_ID': 'Invalid text message id',
        'API.INVALID_TIMEZONE_ID': 'Invalid timezone id',
        'API.INVALID_TOKEN': 'Invalid token',
        'API.INVALID_TOPIC': 'Invalid topic',
        'API.INVALID_UNIT_OF_MEASURE': 'Invalid unit of measure',
        'API.INVALID_UNIT_OF_PRICE': 'Invalid unit of price',
        'API.INVALID_UNITS': 'Invalid units',
        'API.INVALID_USER_ID': 'Invalid user id',
        'API.INVALID_USER_NAME': 'Invalid user name',
        'API.INVALID_USER_NAME_OR_EMAIL': 'Invalid user name or email',
        'API.INVALID_USER_PHONE': 'Invalid user phone',
        'API.INVALID_USER_PLEASE_RE_LOGIN': 'Invalid user please re-login',
        'API.INVALID_USER_UUID': 'Invalid user uuid',
        'API.INVALID_USERNAME': 'Invalid userName',
        'API.INVALID_VARIABLE_METER_ID': 'Invalid variable meter id',
        'API.INVALID_VARIABLE_METER_TYPE': 'Invalid variable meter type',
        'API.INVALID_VARIABLE_NAME': 'Invalid variable name',
        'API.INVALID_VERIFICATION_CODE': 'Invalid verification code',
        'API.INVALID_VIRTUAL_METER_ID': 'Invalid virtual meter id',
        'API.INVALID_VIRTUAL_METER_NAME': 'Invalid virtual meter name',
        'API.INVALID_VIRTUAL_METER_UUID': 'Invalid virtual meter uuid',
        'API.INVALID_WEB_MESSAGE_ID': 'Invalid web message id',
        'API.INVALID_WECHAT_MESSAGE_ID': 'Invalid wechat message id',
        'API.INVALID_WIND_FARM_ID': 'Invalid wind farm ID',
        'API.INVALID_WIND_FARM_NAME': 'Invalid wind farm name',
        'API.INVALID_WORKING_CALENDAR_ID': 'Invalid working calendar id ',
        'API.INVALID_WORKING_CALENDAR_NAME': 'Invalid working calendar name',
        'API.KNOWLEDGE_FILE_CANNOT_BE_REMOVED_FROM_DISK': 'Knowledge File Cannot be Removed from Disk',
        'API.KNOWLEDGE_FILE_NOT_FOUND': 'Knowledge file not found',
        'API.MASTER_METER_DOES_NOT_BELONG_TO_SAME_ENERGY_CATEGORY':
            'Master meter does not belong to same energy category',
        'API.MASTER_METER_NOT_FOUND': 'Master meter not found',
        'API.MENU_NOT_FOUND': 'Menu not found',
        'API.METER_CANNOT_HAVE_MORE_THAN_ONE_ENERGY_VALUE_POINTS': 'Meter cannot have more than one energy value points',
        'API.METER_COMMAND_RELATION_EXISTS': 'Meter command relation exists',
        'API.METER_COMMAND_RELATION_NOT_FOUND': 'Meter command relation not found',
        'API.METER_NAME_IS_ALREADY_IN_USE': 'Meter name is already in use',
        'API.METER_NOT_FOUND': 'Meter not found',
        'API.METER_OF_VARIABLE_NOT_FOUND': 'Meter of variable not found',
        'API.METER_POINT_RELATION_EXISTS': 'Meter point relation exists',
        'API.METER_POINT_RELATION_NOT_FOUND': 'Meter point relation not found',
        'API.MICROGRID_BATTERY_NAME_IS_ALREADY_IN_USE': 'Microgrid battery name is already in use',
        'API.MICROGRID_BATTERY_NOT_FOUND': 'Microgrid battery not found',
        'API.MICROGRID_EVCHARGER_NAME_IS_ALREADY_IN_USE': 'Microgrid evcharger name is already in use',
        'API.MICROGRID_EVCHARGER_NOT_FOUND': 'Microgrid evcharger not fund',
        'API.MICROGRID_GENERATOR_NAME_IS_ALREADY_IN_USE': 'Microgrid generator name is already in use',
        'API.MICROGRID_GENERATOR_NOT_FOUND': 'Microgrid generator not found',
        'API.MICROGRID_GRID_NAME_IS_ALREADY_IN_USE': 'Microgrid grid name is already in use',
        'API.MICROGRID_GRID_NOT_FOUND': 'Microgrid grid not found',
        'API.MICROGRID_HEATPUMP_NAME_IS_ALREADY_IN_USE': 'Microgrid heatpump name is already in use',
        'API.MICROGRID_HEATPUMP_NOT_FOUND': 'Microgrid heatpump not found',
        'API.MICROGRID_LOAD_NAME_IS_ALREADY_IN_USE': 'Microgrid load name is already',
        'API.MICROGRID_LOAD_NOT_FOUND': 'Microgrid load not found',
        'API.MICROGRID_NAME_IS_ALREADY_IN_USE': 'Microgrid name is already in use',
        'API.MICROGRID_NOT_FOUND': 'Microgrid not found',
        'API.MICROGRID_PHOTOVOLTAIC_NAME_IS_ALREADY_IN_USE': 'Microgrid photovoltaic name is already in use',
        'API.MICROGRID_PHOTOVOLTAIC_NOT_FOUND': 'Microgrid photovoltaic not found',
        'API.MICROGRID_POWER_CONVERSION_SYSTEM_NAME_IS_ALREADY_IN_USE':
            'Microgrid power conversion system name is already in use',
        'API.MICROGRID_POWER_CONVERSION_SYSTEM_NOT_FOUND': 'Microgrid power conversion system not found',
        'API.MICROGRID_SENSOR_RELATION_EXISTS': 'Microgrid sensor relation exists',
        'API.MICROGRID_SENSOR_RELATION_NOT_FOUND': 'Microgrid sensor not found',
        'API.MQTT_CONNECTION_ERROR': 'Mqtt connection error',
        'API.MQTT_PUBLISH_ERROR': 'Mqtt publish error',
        'API.NEW_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'New password length cannot exceed 100 characters',
        'API.NEW_USER_SESSION_NOT_FOUND': 'New user session not found',
        'API.NEW_USER_SESSION_TIMEOUT': 'New user session timeout',
        'API.NON_WORKING_DAY_NOT_FOUND': 'Non working day non found',
        'API.NOT_FOUND': 'Not found',
        'API.NOTIFICATION_NOT_FOUND': 'Notification not found',
        'API.OFFLINE_METER_FILE_NOT_FOUND': 'Offline meter file not found',
        'API.OFFLINE_METER_NAME_IS_ALREADY_IN_USE': 'Offline meter name is already in use',
        'API.OFFLINE_METER_NOT_FOUND': 'Offline meter not found',
        'API.INVALID_OFFLINE_METER_VALUE': 'Nilai meter luar talian tidak sah',
        'API.OFFLINE_METER_OF_VARIABLE_NOT_FOUND': 'Offline meter of variable not found',
        'API.OLD_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Old password length cannot exceed 100 characters',
        'API.PARENT_SPACE_NOT_FOUND': 'Parent space not found',
        'API.PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Password length cannot exceed 100 characters',
        'API.PASSWORDS_MATCH': 'New password is the same as the old password',
        'API.PHOTOVOLTAIC_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Photovoltaic power station name is already in use',
        'API.PHOTOVOLTAIC_POWER_STATION_NOT_FOUND': 'Photovoltaic power station not found',
        'API.POINT_NAME_IS_ALREADY_IN_USE': 'Point name is already in use',
        'API.POINT_NOT_FOUND': 'Point not found',
        'API.POWER_POINT_NOT_FOUND': 'Power point not found',
        'API.PRIVILEGE_NAME_IS_ALREADY_IN_USE': 'Privilege name is already in use',
        'API.PRIVILEGE_NOT_FOUND': 'Privilege not found',
        'API.RULE_NAME_IS_ALREADY_IN_USE': 'Rule name is already in use',
        'API.RULE_NOT_FOUND': 'Rule not found',
        'API.SELL_METER_NOT_FOUND': 'Sell meter not found',
        'API.SENSOR_NAME_IS_ALREADY_IN_USE': 'Sensor name is already in use',
        'API.SENSOR_NOT_FOUND': 'Sensor not found',
        'API.SENSOR_POINT_RELATION_EXISTS': 'Sensor point relation exists',
        'API.SENSOR_POINT_RELATION_NOT_FOUND': 'Sensor point relation not found',
        'API.SHOPFLOOR_COMMAND_RELATION_EXISTS': 'Shopfloor command relation exists',
        'API.SHOPFLOOR_COMMAND_RELATION_NOT_FOUND': 'Shopfloor command relation not found',
        'API.SHOPFLOOR_EQUIPMENT_RELATION_EXISTS': 'Shopfloor equipment relation exists',
        'API.SHOPFLOOR_EQUIPMENT_RELATION_NOT_FOUND': 'Shopfloor equipment relation not found',
        'API.SHOPFLOOR_METER_RELATION_EXISTS': 'Shopfloor meter relation exists',
        'API.SHOPFLOOR_METER_RELATION_NOT_FOUND': 'Shopfloor meter relation not found',
        'API.SHOPFLOOR_NAME_IS_ALREADY_IN_USE': 'Shopfloor name is already in use',
        'API.SHOPFLOOR_NOT_FOUND': 'Shopfloor not found',
        'API.SHOPFLOOR_OFFLINE_METER_RELATION_EXISTS': 'Shopfloor offline meter relation exists',
        'API.SHOPFLOOR_OFFLINE_METER_RELATION_NOT_FOUND': 'Shopfloor offline meter relation not found',
        'API.SHOPFLOOR_POINT_RELATION_EXISTS': 'Shopfloor point relation exists',
        'API.SHOPFLOOR_POINT_RELATION_NOT_FOUND': 'Shopfloor point relation not found',
        'API.SHOPFLOOR_SENSOR_RELATION_EXISTS': 'Shopfloor sensor relation exists',
        'API.SHOPFLOOR_SENSOR_RELATION_NOT_FOUND': 'Shopfloor sensor relation not found',
        'API.SHOPFLOOR_VIRTUAL_METER_RELATION_EXISTS': 'Shopfloor virtual meter relation exists',
        'API.SHOPFLOOR_VIRTUAL_METER_RELATION_NOT_FOUND': 'Shopfloor virtual meter relation not found',
        'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_EXISTS': 'Shopfloor working calendar relation exists',
        'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Shopfloor working calendar relation not found',
        'API.SOC_POINT_NOT_FOUND': 'SOC point not found',
        'API.SOURCE_NODE_NOT_FOUND': 'Source node not found',
        'API.SPACE_COMBINED_EQUIPMENT_RELATION_EXISTS': 'Space combined equipment relation exists',
        'API.SPACE_COMBINED_EQUIPMENT_RELATION_NOT_FOUND': 'Space combined equipment relation not found',
        'API.SPACE_COMMAND_RELATION_EXISTS': 'Space command relation exists',
        'API.SPACE_COMMAND_RELATION_NOT_FOUND': 'Space command relation not found',
        'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_EXISTS': 'Space Energy Storage Power Station Relation Exists',
        'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_NOT_FOUND': 'Space Energy Storage Power Station Relation Not Found',
        'API.SPACE_EQUIPMENT_RELATION_EXISTS': 'Space equipment relation exists',
        'API.SPACE_EQUIPMENT_RELATION_NOT_FOUND': 'Space equipment relation not found',
        'API.SPACE_METER_RELATION_EXISTS': 'Space meter relation exists',
        'API.SPACE_METER_RELATION_NOT_FOUND': 'Space meter relation not found',
        'API.SPACE_NAME_IS_ALREADY_IN_USE': 'Space name is already in use',
        'API.SPACE_NOT_FOUND': 'Space not found',
        'API.SPACE_NOT_FOUND_IN_PRIVILEGE': 'Space not found in privilege',
        'API.SPACE_OFFLINE_METER_RELATION_EXISTS': 'Space offline meter relation exists',
        'API.SPACE_OFFLINE_METER_RELATION_NOT_FOUND': 'Space offline meter relation not found',
        'API.SPACE_POINT_RELATION_EXISTS': 'Space point relation exists',
        'API.SPACE_POINT_RELATION_NOT_FOUND': 'Space point relation not found',
        'API.SPACE_SENSOR_RELATION_EXISTS': 'Space sensor relation exists',
        'API.SPACE_SENSOR_RELATION_NOT_FOUND': 'Space sensor relation not found',
        'API.SPACE_SHOPFLOOR_RELATION_EXISTS': 'Space shopfloor relation exists',
        'API.SPACE_SHOPFLOOR_RELATION_NOT_FOUND': 'Space shopfloor relation not found',
        'API.SPACE_STORE_RELATION_EXISTS': 'Space store relation exists',
        'API.SPACE_STORE_RELATION_NOT_FOUND': 'Space store relation not found',
        'API.SPACE_TENANT_RELATION_EXISTS': 'Space tenant relation exists',
        'API.SPACE_TENANT_RELATION_NOT_FOUND': 'Space tenant relation not found',
        'API.SPACE_VIRTUAL_METER_RELATION_EXISTS': 'Space virtual meter relation exists',
        'API.SPACE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Space virtual meter relation not found',
        'API.SPACE_WORKING_CALENDAR_RELATION_EXISTS': 'Space working calendar relation exists',
        'API.SPACE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Space working calendar relation not found',
        'API.START_DATETIME_MUST_BE_EARLIER_THAN_END_DATETIME': 'Start datetime must be early than end datetime',
        'API.STORE_COMMAND_RELATION_EXISTS': 'Store command relation exists',
        'API.STORE_COMMAND_RELATION_NOT_FOUND': 'Store command relation not found',
        'API.STORE_METER_RELATION_EXISTS': 'Store meter relation exists',
        'API.STORE_METER_RELATION_NOT_FOUND': 'Store meter relation not found',
        'API.STORE_NAME_IS_ALREADY_IN_USE': 'Store name is already in use',
        'API.STORE_NOT_FOUND': 'Store not found',
        'API.STORE_OFFLINE_METER_RELATION_EXISTS': 'Store offline meter relation exists',
        'API.STORE_OFFLINE_METER_RELATION_NOT_FOUND': 'Store offline meter relation not found',
        'API.STORE_POINT_RELATION_EXISTS': 'Store point relation exists',
        'API.STORE_POINT_RELATION_NOT_FOUND': 'Store point relation not found',
        'API.STORE_SENSOR_RELATION_EXISTS': 'Store sensor relation exists',
        'API.STORE_SENSOR_RELATION_NOT_FOUND': 'Store sensor relation not found',
        'API.STORE_TYPE_NAME_IS_ALREADY_IN_USE': 'Store type name is already in use',
        'API.STORE_TYPE_NOT_FOUND': 'Store type not found',
        'API.STORE_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Store type simplified code is already in use',
        'API.STORE_TYPE_USED_IN_STORE': 'Store type used in store',
        'API.STORE_VIRTUAL_METER_RELATION_EXISTS': 'Store virtual meter relation exists',
        'API.STORE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Store virtual meter relation not found',
        'API.STORE_WORKING_CALENDAR_RELATION_EXISTS': 'Store working calendar relation exists',
        'API.STORE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Store working calendar relation not found',
        'API.TARGET_NODE_NOT_FOUND': 'Target node not found',
        'API.TARIFF_IN_USE': 'Tariff in use',
        'API.TARIFF_IS_ALREADY_ASSOCIATED_WITH_COST_CENTER': 'Tariff is already associated with cost center',
        'API.TARIFF_IS_NOT_ASSOCIATED_WITH_COST_CENTER': 'Tariff is not associated with cost center',
        'API.TARIFF_NAME_IS_ALREADY_IN_USE': 'Tariff name is already in use',
        'API.TARIFF_NOT_FOUND': 'Tariff not found',
        'API.TENANT_COMMAND_RELATION_EXISTS': 'Tenant command relation exists',
        'API.TENANT_COMMAND_RELATION_NOT_FOUND': 'Tenant command relation  not found',
        'API.TENANT_METER_RELATION_EXISTS': 'Tenant meter relation exists',
        'API.TENANT_METER_RELATION_NOT_FOUND': 'Tenant meter relation not found',
        'API.TENANT_NAME_IS_ALREADY_IN_USE': 'Tenant name is already in use',
        'API.TENANT_NOT_FOUND': 'Tenant not found',
        'API.TENANT_OFFLINE_METER_RELATION_EXISTS': 'Tenant offline meter relation exists',
        'API.TENANT_OFFLINE_METER_RELATION_NOT_FOUND': 'Tenant offline meter relation not found',
        'API.TENANT_POINT_RELATION_EXISTS': 'Tenant point relation exists',
        'API.TENANT_POINT_RELATION_NOT_FOUND': 'Tenant point relation not found',
        'API.TENANT_SENSOR_RELATION_EXISTS': 'Tenant sensor relation exists',
        'API.TENANT_SENSOR_RELATION_NOT_FOUND': 'Tenant sensor relation not found',
        'API.TENANT_TYPE_NAME_IS_ALREADY_IN_USE': 'Tenant type name is already in use',
        'API.TENANT_TYPE_NOT_FOUND': 'Tenant type not found',
        'API.TENANT_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Tenant type simplified code is already in use',
        'API.TENANT_TYPE_USED_IN_TENANT': 'Tenant type used in tenant',
        'API.TENANT_VIRTUAL_METER_RELATION_EXISTS': 'Tenant virtual meter relation exists',
        'API.TENANT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Tenant virtual meter relation not found',
        'API.TENANT_WORKING_CALENDAR_RELATION_EXISTS': 'Tenant working calendar relation exists',
        'API.TENANT_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Tenant working calendar relation not found',
        'API.TEXT_MESSAGE_NOT_FOUND': 'Text message not found',
        'API.THE_REPORTING_PERIOD_MUST_BE_LONGER_THAN_15_MINUTES': 'The reporting period must be longer than 15 minutes',
        'API.THERE_IS_RELATION_WITH_CHILD_METERS': 'There is relation with child meters',
        'API.THERE_IS_RELATION_WITH_CHILDREN_SPACES': 'There is relation with children spaces',
        'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENT_PARAMETERS':
            'There is relation with combined equipment parameters',
        'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENTS': 'There is relation with combined equipments',
        'API.THERE_IS_RELATION_WITH_DATA_SOURCES': 'There is relation with data sources',
        'API.THERE_IS_RELATION_WITH_ENERGY_FLOW_DIAGRAM_LINKS': 'There is relation with energy flow diagram links',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_BATTERIES': 'There Is Relation With Energy Storage Containers Batteries',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_GRIDS': 'There Is Relation With Energy Storage Containers Grids',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_LOADS': 'There Is Relation With Energy Storage Containers Loads',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_POWER_CONVERSION_SYSTEMS': 'There Is Relation With Energy Storage Containers Power Conversion Systems',
        'API.THERE_IS_RELATION_WITH_EQUIPMENT_PARAMETERS': 'There is relation with equipment parameters',
        'API.THERE_IS_RELATION_WITH_EQUIPMENTS': 'There is relation with equipments',
        'API.THERE_IS_RELATION_WITH_METER': 'There is relation with meter',
        'API.THERE_IS_RELATION_WITH_METERS': 'There is relation with meters',
        'API.THERE_IS_RELATION_WITH_OFFLINE_METER': 'There is relation with offline meter',
        'API.THERE_IS_RELATION_WITH_OFFLINE_METERS': 'There is relation with offline meters',
        'API.THERE_IS_RELATION_WITH_OTHER_VIRTUAL_METERS': 'There is relation with other virtual meters',
        'API.THERE_IS_RELATION_WITH_SENSORS': 'There is relation with sensors',
        'API.THERE_IS_RELATION_WITH_SHOPFLOORS': 'There is relation with shopfloors',
        'API.THERE_IS_RELATION_WITH_SPACES': 'There is relation with spaces',
        'API.THERE_IS_RELATION_WITH_STORES': 'There is relation with stores',
        'API.THERE_IS_RELATION_WITH_TENANTS': 'There is relation with tenants',
        'API.THERE_IS_RELATION_WITH_USERS': 'There is relation with users',
        'API.THERE_IS_RELATION_WITH_VIRTUAL_METER': 'There is relation with virtual meter',
        'API.THERE_IS_RELATION_WITH_VIRTUAL_POWER_PLANTS': 'Ada hubungan dengan Pjantan Kuasa Maya',
        'API.THIS_DATA_SOURCE_IS_BEING_USED_BY_A_METER': 'This data source is being used by a meter',
        'API.THIS_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'This meter is being used by a virtual meter',
        'API.THIS_OFFLINE_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'This offline meter is being used by a virtual meter',
        'API.THIS_SPACE_CANNOT_BE_CLONED': 'This space cannot be cloned',
        'API.THIS_SPACE_CANNOT_BE_DELETED': 'This space cannot be deleted',
        'API.TIMEZONE_NOT_FOUND': 'Timezone not found',
        'API.TOKEN_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'Token not found in headers please login',
        'API.USER_ACCOUNT_HAS_BEEN_LOCKED': 'User Account Has Been Locked',
        'API.USER_ACCOUNT_HAS_EXPIRED': 'User Account Has Expired',
        'API.USER_ACCOUNT_IS_NOT_LOCKED': 'User account is not locked',
        'API.USER_NAME_IS_ALREADY_IN_USE': 'User name is already in use',
        'API.USER_NOT_FOUND': 'User not found',
        'API.USER_PASSWORD_HAS_EXPIRED': 'User Password Has Expired',
        'API.USER_PRIVILEGE_NOT_FOUND': 'User privilege not found',
        'API.USER_SESSION_NOT_FOUND': 'User session not found',
        'API.USER_SESSION_TIMEOUT': 'User session timeout',
        'API.USER_UUID_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'User uuid not found in headers please login',
        'API.VIRTUAL_METER_NAME_IS_ALREADY_IN_USE': 'Virtual meter name is already in use',
        'API.VIRTUAL_METER_NOT_FOUND': 'Virtual meter not found',
        'API.VIRTUAL_METER_OF_VARIABLE_NOT_FOUND': 'Virtual meter of variable not found',
        'API.VIRTUAL_POINT_SHOULD_BE_ANALOG_VALUE': 'Virtual point should be analog value',
        'API.WEB_MESSAGE_NOT_FOUND': 'Web message not found',
        'API.WECHAT_MESSAGE_NOT_FOUND': 'Wechat message not found',
        'API.WIND_FARM_NAME_IS_ALREADY_IN_USE': 'Wind farm name is already in use',
        'API.WIND_FARM_NOT_FOUND': 'Wind farm not found',
        'API.WORKING_CALENDAR_NAME_IS_ALREADY_IN_USE': 'Working calendar name is already in use',
        'API.WORKING_CALENDAR_NOT_FOUND': 'Working calendar not found',

        MasterMeter: 'Jadual Ringkasan',
        SubMeter: 'Subjadual',
        'Power Quality': 'Kualitas daya',
        'About Power Quality': 'Tentang kualitas daya',
        Category: 'Kategori',
        Type: 'Jenis',
        Limit: 'Batas',
        'Normal Limit': 'Batas normal',
        'Severe Limit': 'Batas berat',
        Compliance: 'Tingkat kepatuhan',
        'Worst Deviation': 'Deviasi terburuk',
        'Worst Time': 'Waktu terburuk',
        'Severe Exceed Count': 'Jumlah pelampauan berat',
        'Worst Unbalance': 'Ketidakseimbangan maksimum',
        Hz: 'Hz',
        voltage: 'Tegangan',
        current: 'Arus',
        frequency: 'Frekuensi',
        voltage_deviation: 'Penyimpangan tegangan',
        current_unbalance: 'Ketidakseimbangan arus',
        voltage_unbalance: 'Ketidakseimbangan tegangan',
        mean_deviation_pct: 'Penyimpangan rata-rata (%)',
        p95_abs_deviation_pct: 'Penyimpangan absolut P95 (%)',
        mean_abs_deviation_hz: 'Penyimpangan absolut rata-rata (Hz)',
        frequency_deviation: 'Penyimpangan frekuensi',
        p95_abs_deviation_hz: 'Penyimpangan absolut P95 (Hz)',
        mean_unbalance_pct: 'Ketidakseimbangan rata-rata (%)',
        p95_unbalance_pct: 'Ketidakseimbangan P95 (%)',
        count: 'Jumlah',
        min: 'Min',
        max: 'Maks',
        mean: 'Rata-rata',
        std: 'Simpangan baku',
        p5: 'P5',
        p95: 'P95'
    }
};
